import styled, { css, type CSSProperties } from "styled-components";
import tw from "twin.macro";
import TextField, { type ITextFieldProps } from "@atoms/TextField";
import Paragraph from "@atoms/Paragraph";

interface StyledSelectInputProps extends ITextFieldProps {
  $cursor?: CSSProperties["cursor"];
}

const styles = {
  text: {
    state: {
      error: tw`text-error-30`,
      success: tw`text-tertiary-50`,
      disabled: tw`text-neutral-80`,
      default: tw`text-[#4F4F4F]`,
    },
  },
};

export const StyledSelectInput = styled(TextField)<StyledSelectInputProps>`
  ${({ $cursor }) => css`
    cursor: ${$cursor ?? "text"};
  `}
`;

export const StyledText = styled(Paragraph)<{
  $disabled?: boolean;
  $errors?: boolean;
  $success?: boolean;
}>`
  ${({ $disabled, $errors, $success }) => {
    if ($disabled) return styles.text.state.disabled;
    if ($errors && !$disabled) return styles.text.state.error;
    if ($success && !$disabled) return styles.text.state.success;
    return styles.text.state.default;
  }}
`;
